import React from 'react';
import api from '../irelandApi';
import {
  GET_PRIZE_FULFILLED,
  GET_PRIZE_PENDING,
  GET_PRIZE_REJECTED,
  ADD_PRIZE_PENDING,
  ADD_PRIZE_REJECTED,
  ADD_PRIZE_FULFILLED,
  UPDATE_PRIZE_FULFILLED,
  UPDATE_PRIZE_PENDING,
  UPDATE_PRIZE_REJECTED,
  GET_PRIZES_FULFILLED,
  GET_PRIZES_PENDING,
  GET_PRIZES_REJECTED,
  DELETE_PRIZE_PENDING,
  DELETE_PRIZE_FULFILLED,
  DELETE_PRIZE_REJECTED,
  GET_PRIZE_META_PENDING,
  GET_PRIZE_META_FULFILLED,
  GET_PRIZE_META_REJECTED,
  GET_PRIZE_OUTLET_INCENTIVES_PENDING,
  GET_PRIZE_OUTLET_INCENTIVES_FULFILLED,
  GET_PRIZE_OUTLET_INCENTIVES_REJECTED
} from '../reducers/prizesReducer';
import { toast } from 'react-toastify';
import { history } from '../store';
import { actions } from 'react-redux-form';
import ToastMessage from '../components/common/toast-message';

const PRIZES_URL = '/api/admin/prizes';
const INITIAL_PAGE = 1;

export const getPrize = id => dispatch => {
  const url = `/api/admin/prizes/${id}`;
  dispatch({ type: GET_PRIZE_PENDING });
  return api
    .get(url)
    .then(response => {
      if (id) {
        const prize = {
          outlet_id: response.data.data.attributes['outlet-id'],
          incentive_id: response.data.data.attributes['incentive-id'],
          name: response.data.data.attributes.name,
          description: response.data.data.attributes.description,
          value: response.data.data.attributes.value,
          award_date: response.data.data.attributes['award-date']
        };
        dispatch(actions.load('deep.prize', prize));
      }
      dispatch({
        type: GET_PRIZE_FULFILLED,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_PRIZE_REJECTED,
        payload: error.response
      });
    });
};

export const addPrize = payload => dispatch => {
  dispatch({ type: ADD_PRIZE_PENDING });
  return api
    .post(PRIZES_URL, { prize: payload })
    .then(response => {
      dispatch({
        type: ADD_PRIZE_FULFILLED,
        payload: response.data
      });
      toast.success(
        <ToastMessage
          iconStyle="success"
          message="Prize has been saved successfully"
        />
      );
      dispatch(actions.reset('deep.prize'));
    })
    .catch(error => {
      const errorData = error.hasOwnProperty('response')
        ? error.response.data.errors
        : [];
      dispatch({
        type: ADD_PRIZE_REJECTED,
        payload: errorData
      });
      toast.error(
        <ToastMessage iconStyle="error" message="Error while saving prize" />
      );

      return Promise.reject(errorData);
    });
};

export const updatePrize = (id, payload) => (dispatch) => {
  dispatch({ type: UPDATE_PRIZE_PENDING });

  return api
  .patch(`${PRIZES_URL}/${id}`, { prize: payload })
  .then((response) => {
   dispatch({
     type: UPDATE_PRIZE_FULFILLED,
     payload: response.data
   });
   toast.success(
     <ToastMessage
       iconStyle="success"
       message="Prize has been saved successfully"
     />
   );
  })
  .catch((error) => {
   const errorData = error.hasOwnProperty('response')
     ? error.response.data.errors
     : [];
   dispatch({
     type: UPDATE_PRIZE_REJECTED,
     payload: errorData
   });
   toast.error(
     <ToastMessage
       iconStyle="error"
       message="Error while saving prize"
     />
   );

   return Promise.reject(errorData);
  })
  .then(() => {
   history.push('/admin/prizes');
  });
};

export const deletePrize = (id) => (dispatch) => {
  dispatch({ type: DELETE_PRIZE_PENDING });
  return api
    .delete(PRIZES_URL + '/' + id)
    .then((response) => {
      dispatch({
        type: DELETE_PRIZE_FULFILLED,
        payload: id
      });
      toast.success(
       <ToastMessage
         iconStyle="success"
         message="Prize has been deleted successfully"
       />
      )
    })
    .catch((error) => {
      dispatch({
        type: DELETE_PRIZE_REJECTED,
        payload: error.response
      });
      toast.error(
       <ToastMessage
         iconStyle="error"
         message="Error while deleting prize"
       />
      )
    });
};

export const getPrizes = (page = INITIAL_PAGE, query = null) => (dispatch) => {
  dispatch({ type: GET_PRIZES_PENDING });
  return api
    .get(PRIZES_URL, { params: { page: page, query: query } })
    .then((response) => {
      dispatch({
        type: GET_PRIZES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRIZES_REJECTED,
        payload: error.response
      });
    });
};

export const getPrizeMeta = () => (dispatch) => {
  dispatch({ type: GET_PRIZE_META_PENDING });
  return api
    .get('api/admin/prizes/meta')
    .then((response) => {
      dispatch({
        type: GET_PRIZE_META_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRIZE_META_REJECTED,
        payload: error.response
      });
    });
};

export const getPrizeOutletIncentives = (payload) => (dispatch) => {
  dispatch({ type: GET_PRIZE_OUTLET_INCENTIVES_PENDING });
  return api
    .get(`/api/admin/outlets/outlet_incentives?outlet_id=${payload}`)
    .then((response) => {
      dispatch({
        type: GET_PRIZE_OUTLET_INCENTIVES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRIZE_OUTLET_INCENTIVES_REJECTED,
        payload: error.response
      });
    });
};



// WEBPACK FOOTER //
// ./src/actions/prizes.js